import { create } from "zustand";

import { getCountries, getCountryConfigMap } from "@/config/country.config";
import { ICountryValue } from "@/types/country.types";

interface ICountryStore {
  country: ICountryValue;
  countryList: ICountryValue[];
  setCounty: (val: string) => void;
}

// Get default country from environment variable
const getDefaultCountry = (): ICountryValue => {
  const defaultCountryKey = (
    process.env.NEXT_PUBLIC_COUNTRY || "georgia"
  ).toLowerCase();
  const countryConfig = getCountryConfigMap();
  const defaultCountry = countryConfig.get(defaultCountryKey);

  // Fallback to first country if key not found
  if (!defaultCountry) {
    const firstCountry = countryConfig.values().next().value;
    return firstCountry || ({} as ICountryValue);
  }

  return defaultCountry;
};

const initialValue = getDefaultCountry();

export const useCountryStore = create<ICountryStore>((set) => ({
  country: initialValue,
  countryList: getCountries(),
  setCounty: (val) =>
    set(() => {
      const countryConfig = getCountryConfigMap();
      const selectedCountry = countryConfig.get(val);
      return {
        country: selectedCountry || initialValue,
      };
    }),
}));
